import { Component, OnInit, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { Http } from "@angular/http";
import { Router }  from '@angular/router';
import { Member } from '../member/member';
import { MemberService } from '../member/member.service';
import * as firebase from 'firebase';
import * as _ from 'underscore';

import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/modern/theme';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/table';
import 'tinymce/plugins/image';
import 'tinymce/plugins/media';
import 'tinymce/plugins/imagetools';
/**
 * Modules
 */
import { AlertModule } from 'ng2-bootstrap';

//import {DataTableModule} from "angular2-datatable";

@Component({
  selector: 'cef-journey',
  templateUrl: './journey-rec.component.html'
})

export class JourneyRecComponent implements OnInit {
	@Output() onEditorKeyup = new EventEmitter<any>();
	public existChapter = new Array();
	public currUser = {
		uid:'',
		email:'',
		level:'',
		unit:''
	};
	public allProfile;
	public detailMem = '';
	public qaImg = 0;
	public replyNum = '';
	public journeyRecs;
	public msgTo = '';
	public msgTitle = '';
	public msgContent = '';
	public warningMsg = '';
	public contentMsg = {};

	public filterQuery = "";
    public rowsOnPage = 10;
    public sortBy = "sendDate";
    public sortOrder = "desc";

	public chapterThumb = new Array();
	public s3ChapterParams = {
		Bucket: 'cefkid-journey',
		Delimiter: '/'
	};

	editor;

 	constructor(private http: Http, private router: Router, private memberService: MemberService) {
		
	}

	ngAfterViewInit() {
		tinymce.init({
		  selector: '#replyEditor',
		  plugins: ['link', 'paste', 'textcolor', 'autolink', 'emoticons', 'table','image', 'media', 'imagetools'],
		  skin_url: '../assets/skins/lightgray',
		  toolbar1: 'undo redo styleselect bold italic alignleft aligncenter alignright bullist numlist outdent indent code',
		  toolbar2: 'emoticons image media link paste forecolor backcolor',
		  paste_data_images: false, 
		  min_height: 200, 
		  setup: editor => {
		    this.editor = editor;
		    editor.on('keyup', () => {
		      const content = editor.getContent();
		      this.onEditorKeyup.emit(content);
		    });
		  },
		});
	}

	ngOnInit(): void {
		/**
		this.memberService.s3.listObjectsV2(this.s3ChapterParams, (err, data) => {
			if (!err) {
				if (data.CommonPrefixes.length) {
					for (var chapter of data.CommonPrefixes){
						var chapterName = chapter.Prefix.replace('/','');
						this.existChapter.push(chapterName.substr(7));
					}
				}
			} else {
				console.log(err);
			}
		});
		**/

		let db = firebase.database();

		firebase.auth().onAuthStateChanged((user:any) => {
		  if (user) {
		    this.currUser.uid = user.uid;
			//this.currUser.uid = 'fVEPM5dJXtffS1XVNLEbRJxFgR92';
		    this.currUser.email = user.email;
		    db.ref('profile/'+this.currUser.uid).once('value').then(
				(snapshot:any) => {
					if (snapshot.val()){
						let returnVal = snapshot.val();
						this.currUser.level = returnVal.level;
						this.currUser.unit = returnVal.unit;
						let db = firebase.database();
						db.ref('journeyRecords/'+this.currUser.uid).once('value').then(
							(snapshot:any) => {
								if (snapshot.val()){
									this.journeyRecs = snapshot.val().reverse();
									//get student feedback
									db.ref('memberMsg/'+this.currUser.uid).once('value').then(
										(snapshot:any)=>{
											if (snapshot.val()){
												var allInMsg = snapshot.val().in?snapshot.val().in:{};
												var allOutMsg = snapshot.val().out?snapshot.val().out:{};
												var allMsg = [];
												for(let msgId in allInMsg){
													if (allInMsg[msgId].type != '栽培回應') continue;
													db.ref('message/'+allInMsg[msgId].contentId).once('value').then(
														(snapshot:any)=>{
															this.contentMsg[allInMsg[msgId].contentId] = snapshot.val();
														}
													)
													let msgObj = {
														id:msgId, 
														msgBox: 'in',
														contentId:allInMsg[msgId].contentId,
														sendDate:allInMsg[msgId].sendDate, 
														sendFrom:allInMsg[msgId].sendFrom, 
														title:allInMsg[msgId].title, 
														type:allInMsg[msgId].type
													}
													allMsg.push(msgObj);
												}
												for(let msgId in allOutMsg){
													if (allOutMsg[msgId].type != '栽培回應') continue;
													db.ref('message/'+allOutMsg[msgId].contentId).once('value').then(
														(snapshot:any)=>{
															this.contentMsg[allOutMsg[msgId].contentId] = snapshot.val();
														}
													)
													let msgObj = {
														id:msgId, 
														msgBox: 'out',
														contentId:allOutMsg[msgId].contentId,
														sendDate:allOutMsg[msgId].sendDate, 
														sendTo:allOutMsg[msgId].sendTo, 
														title:allOutMsg[msgId].title, 
														type:allOutMsg[msgId].type
													}
													allMsg.push(msgObj);
												}

												allMsg.sort(this._dateSort);
												//_.sortBy(allMsg, 'sendDate');
												this.journeyRecs.reply = [];
												for(var i=1; i<this.journeyRecs.length; i++){
													var searchStr = '栽培第'+i+'課';
													this.journeyRecs.reply[i] = [];
													_.each(allMsg, (msg)=>{
														if (msg.title.indexOf(searchStr) != -1) this.journeyRecs.reply[i].push(msg);
													})
												}
											}
										}
									)
								} else {
									this.journeyRecs = [];
								}
							}
						);
					}
				}
			)
		  }
		});	   
    }
	
	_dateSort(a, b){
		var dateA = new Date(a.sendDate).getTime();
		var dateB = new Date(b.sendDate).getTime();
		return dateA < dateB ? 1 : -1;  
	}

	generateArray(obj){
		if (obj.created !== undefined) delete obj.created
		return Object.keys(obj).map((key)=>{return obj[key]});
	}

	showQA(chapter:number){
		this.qaImg = chapter;
	}

	showReply(uid:string, chapter:number){
		if (this.replyNum == uid+chapter){
			this.replyNum = '';
		} else {
			this.replyNum = uid+chapter;
		}
	}

	reply(uid:string, chapter:number){
		this.msgTo = uid;
		this.msgTitle = '回應栽培第'+chapter+'課';
	}

	confirmReply(){
		this.msgContent = tinymce.activeEditor.getContent();
		if (this.msgContent == '' || this.msgTitle == '' || this.msgTo==''){
			this.warningMsg = '請選擇接收訊息會員，輸入內容及標題！';
			setTimeout(()=>{this.warningMsg = '';},this.memberService.modalDismiss);
			return;
		}
		
		let db = firebase.database();
		db.ref('message/').push({content: this.msgContent}).then(
			(val:any)=>{
				var contentUid = val.key;
				db.ref('memberMsg/'+this.currUser.uid+'/out').push(
					{
						title:this.msgTitle,
						type:'栽培回應',
						contentId:contentUid,
						sendDate:(new Date()).toString(),
						sendTo:[this.msgTo]
					}
				).then(
					(val:any) => {
						db.ref('memberMsg/'+this.msgTo+'/in').push(
							{
								title:this.msgTitle,
								type:'栽培回應',
								contentId:contentUid,
								sendDate:(new Date()).toString(),
								sendFrom:this.currUser.uid
							}
						)
						this.replyNum = '';
						this.warningMsg = '訊息已發送！';
						setTimeout(()=>{
							this.warningMsg = '';
							this.msgTitle = '';
							this.msgTo = '';
						},this.memberService.modalDismiss);
					}
					
				)
			}
		)
	}
}



// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/member/journey-rec.component.ts